<mat-form-field appearance="outline" floatLabel="always" [class.mat-form-field-readonly]="readonly"
  [class.ng-valid]="errors === ''" [id]="idPrefix + '-form-field'">

  <!-- Label -->
  @if (label) {
  <mat-label [id]="idPrefix + '-label'">
    @if (labelTemplate) {
    <template [ngTemplateOutlet]="labelTemplate"></template>
    } @else {
    {{label}}
    }
  </mat-label>
  }

  <!-- Input -->
  <input lcTestId matInput thousandSeparator="," [allowNegativeNumbers]="inputMask?.allowNegative"
    [dropSpecialCharacters]="maskDropSpecialCharacters" [errorStateMatcher]="matcher" [formControl]="formControl"
    [id]="idPrefix + '-input'" [mask]="inputMask?.mask" [patterns]="inputMask?.pattern" [placeholder]="placeholder"
    [readonly]="readonly" (blur)="onBlur()">

  <!-- Hint-->
  @if(hint || hintTemplate) {
  <mat-hint *ngIf="hint; else hintTemplate" class="w-100" [id]="idPrefix + '-hint'">
    {{hint}}
  </mat-hint>
  }

  <!-- Error -->
  @if (formControl && formControl.invalid) {
  <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }

  <!-- Suffix -->
  @if (suffix || suffixTemplate) {
  <div matSuffix>
    @if (suffixTemplate) {
    <template [ngTemplateOutlet]="suffixTemplate"></template>
    } @else {
    @if (suffix) {
    <span>{{suffix}}</span>
    }
    }
  </div>
  }
</mat-form-field>